import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from 'redux/store';

export const useSelect = <T>(selector: (state: RootState) => T, equalityFn?: any): T =>
  useSelector(selector, equalityFn ?? shallowEqual);
